export default __webpack_public_path__ + "static/media/home-about-meteor-large.7c1b1f15.png";